// extracted by mini-css-extract-plugin
export var container = "x_b";
export var email = "x_b1";
export var emails = "x_b0";
export var location = "x_b2";
export var number = "x_bZ";
export var numbers = "x_bY";